import { queryOptions } from "@tanstack/react-query"
import type { components } from "@/shared/lib/api.types"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"
import { SCORE_TICK_MS } from "../dashboard.config"

export type DashboardChild = components["schemas"]["DashboardChildDto"]
export type DashboardRecommendation = components["schemas"]["DashboardRecommendationDto"]
export type DashboardCurrentSession = components["schemas"]["DashboardCurrentSessionDto"]
export type DashboardSession = components["schemas"]["DashboardSessionDto"]
export type DashboardPredictions = components["schemas"]["DashboardPredictionsDto"]
export type Dashboard = components["schemas"]["DashboardDto"]

export function dashboardQueryOptions(childId: string) {
  return queryOptions({
    queryKey: ["dashboard", childId],
    queryFn: () =>
      unwrap(apiClient.GET("/api/children/{childId}/dashboard", { params: { path: { childId } } })),
    refetchInterval: SCORE_TICK_MS,
  })
}
